import gql from 'graphql-tag';

export default gql`
query {
  listEtlPackages {
    items {
      __typename
      id
      name
      version
      queries {
        id
      }
      matrix
      scale
    }
  }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/EtlPackages/AllQuery.js